// extracted by mini-css-extract-plugin
export default {"cls1":"VeloModalSheetCardContent-TitleLoading_cls1__WVduV","cls2":"VeloModalSheetCardContent-TitleLoading_cls2__CTAb3 VeloModalSheetCardContent-TitleLoading_cls1__WVduV"};